import { render, staticRenderFns } from "./PriceInfo.vue?vue&type=template&id=9b59dbd2&"
import script from "./PriceInfo.vue?vue&type=script&lang=js&"
export * from "./PriceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b59dbd2')) {
      api.createRecord('9b59dbd2', component.options)
    } else {
      api.reload('9b59dbd2', component.options)
    }
    module.hot.accept("./PriceInfo.vue?vue&type=template&id=9b59dbd2&", function () {
      api.rerender('9b59dbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceInfo.vue"
export default component.exports